import { getRequiredMessage } from '@monetize/types/common';
import * as z from 'zod';

export const ProfileSchema = z.object({
  name: z.string().nonempty(getRequiredMessage('Name')),
});

export type IProfileSchema = z.infer<typeof ProfileSchema>;

export interface IProfile {
  name: string;
}
